
export default function AddOrder(props){
    return(
        <div>Pagina Agregar Pedido</div>
    );
}